module.exports = __webpack_public_path__ + "img/adeste.fb3af612.jpeg";